export default "__VITE_ASSET__BLmxC$eZ__"